import View from 'ol/View';

export default class GeomodView extends View {
  constructor(view_options = {}, area = {}) {
    let projection = 'EPSG:3857';
    let projectionName = undefined;

    if (window.location.hash.startsWith('#map')) {
      const hash = window.location.hash.replace('#map=', '');
      const parts = hash.split('&');
      const coord = parts[0].split(',');
      const layers = parts[1].replace('layers=', '').split(',');
      if (coord.length === 3 && (layers === undefined || Array.isArray(layers))) {
        const mapView = {
          center: [parseFloat(coord[0]), parseFloat(coord[1])],
          zoom: parseInt(coord[2], 10),
          minZoom: view_options?.minZoom || 0,
          maxZoom: view_options?.maxZoom || 22
        };
        localStorage.setItem('visibleLayers', JSON.stringify(layers));
        localStorage.setItem('mapView', JSON.stringify(mapView))
      } else {
        throw new Error('Permalink malformed');
      }
    }
    
    if (window.location.hash.startsWith('#options')) {
      const optionsHash = window.location.hash.replace('#options=', '');
      const optionsParts = optionsHash.split('&');
      const options = {};
      for (const option of optionsParts) {
        const opt = option.split('=');
        options[opt[0]] = opt[1];
      }
      localStorage.setItem('requestOptions', JSON.stringify(options));
    } else {
      localStorage.setItem('requestOptions', null);
    } 

    const intialView = JSON.parse(localStorage.getItem('mapView')) || { center: [0, 0], zoom: 3 };

    let center = intialView.center
    let zoom = intialView.zoom

    let minZoom = view_options.minZoom || 0;
    minZoom = minZoom < area.minZoom ? area.minZoom : minZoom;
    let maxZoom = view_options.maxZoom || 22;
    maxZoom = maxZoom > area.maxZoom ? area.maxZoom : maxZoom;
    if (area.extent) {
      const bbox = area.extent;
      if (bbox[0] > center[0] || bbox[1] > center[1] || bbox[2] < center[0] || bbox[3] < center[1]) {
        center = [bbox[0] + (bbox[2] - bbox[0]) / 2, bbox[1] + (bbox[3] - bbox[1]) / 2];
      }
      if (zoom > maxZoom) {
        zoom = maxZoom;
      }
      if (zoom < minZoom) {
        zoom = minZoom;
      }
    }

    const superParameters = {
      center,
      zoom,
      extent: area.extent,
      projection: projectionName || projection,
      minZoom,
      maxZoom,
      smoothResolutionConstraint: false,
      constrainResolution: true,
    };

    if (view_options.constrainResolution === false) {
      superParameters.smoothResolutionConstraint = true,
      superParameters.constrainResolution = false;
    }

    super(superParameters);

    this.deltaCenter_ = [0, 0];
    this.enableDetla_ = false;
  }

  centerWithDelta(center) {
    let newCenter;
    if (this.enableDelta_) {
      newCenter = [center[0] - this.deltaCenter_[0], center[1] - this.deltaCenter_[1]];
    } else {
      newCenter = center;
    }
    this.setCenter(newCenter);
  }

  animateWithDelta(options = {}) {
    let newOptions;
    if (this.enableDelta_) {
      newOptions = options;
      if (newOptions.center) {
        newOptions.center = [options.center[0] - this.deltaCenter_[0], options.center[1] - this.deltaCenter_[1]];
      }
    } else {
      newOptions = options;
    }
    this.animate(newOptions);
  }

  enableDelta(enable) {
    this.enableDelta_ = enable;
  }

  setCenterDelta(deltaCenter = [0, 0]) {
    this.deltaCenter_ = deltaCenter;
  }
}
